import type {
  FaceLandmarkerResult,
  HandLandmarkerResult,
  NormalizedLandmark,
} from '@mediapipe/tasks-vision';
import type { FaceFrame, HandFrame, Point3 } from './types';

const toPoints = (landmarks: readonly NormalizedLandmark[]): Point3[] =>
  landmarks.map(({ x, y, z }) => ({ x, y, z }));

/** Résultat Face Landmarker (premier visage) → FaceFrame. */
export function toFaceFrame(
  t: number,
  result: FaceLandmarkerResult,
  { includeLandmarks = true }: { includeLandmarks?: boolean } = {},
): FaceFrame {
  const categories = result.faceBlendshapes[0]?.categories;
  const landmarks = result.faceLandmarks[0];
  if (!categories || !landmarks) return { t, blendshapes: null };
  const blendshapes = Object.fromEntries(categories.map((c) => [c.categoryName, c.score]));
  return includeLandmarks ? { t, blendshapes, landmarks: toPoints(landmarks) } : { t, blendshapes };
}

/** Résultat Hand Landmarker (première main) → HandFrame. */
export function toHandFrame(t: number, result: Pick<HandLandmarkerResult, 'landmarks'>): HandFrame {
  const landmarks = result.landmarks[0];
  return { t, landmarks: landmarks ? toPoints(landmarks) : null };
}
